import * as React from 'react';
import { View, Text, TouchableOpacity, Stylesheet, Linking } from 'react-native'
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import { AuthContext } from '../../contexts/auth/Store';
import Colors from '../../constants/Colors'
import { useNavigation, useRoute } from '@react-navigation/native';
import StyledIcon from '../StyledIcon';
import FontStyles from '../../constants/FontStyle';
import PhoneRep from '../common/PhoneRep';
import HeaderGradient from './HeaderGradient';

function ChatHeader({textColor, bgColor }) {
  const auth = React.useContext(AuthContext);
  const navigation = useNavigation()
  const route = useRoute()

  const callRep = () => {
      if (phoneRep) {
          Linking.openURL('tel:' + phoneRep)
      }
      else {
          Linking.openURL('tel:+2349060552941')
      }
  }

  React.useEffect(() => {
    return () => {
      //
    }
  }, [])

  const [phoneRep, phoneRepLoading] = PhoneRep()

  return (
    <HeaderGradient>
    <View style={{
      flexDirection: 'row',
      backgroundColor: bgColor || 'transparent',
      paddingVertical: 8,
    }}>
      <TouchableOpacity style={{
        paddingHorizontal: 16,
        paddingVertical: 8,
        alignSelf: 'center',
      }}
        onPress={() => navigation.goBack()}>
        <StyledIcon iconName="md-arrow-back" iconColor={textColor || Colors.whiteColor} size={24} iconOnly />
      </TouchableOpacity>
      <View style={{
        flexGrow: 1,
        alignSelf: 'center',
      }}>
        <Text style={[
          FontStyles.medium,
          FontStyles.size17,
          FontStyles.lh20,
          {
            color: textColor || Colors.whiteColor,
            textAlignVertical: 'center',
          }]
        }>Chat Console</Text>
      </View>
      {/* Buttons */}
      {/* <TouchableOpacity
        style={{
          alignSelf: 'center',
          paddingLeft: 16,
          paddingRight: 16,
          paddingVertical: 8,
        }}
        onPress={() => navigation.navigate('Home')}
      >
        <StyledIcon iconName="md-home" iconColor="white" size={24} />
      </TouchableOpacity> */}
      <TouchableOpacity
        style={{
          alignSelf: 'center',
          paddingLeft: 8,
          paddingRight: 16,
          paddingVertical: 8,
        }}
        onPress={callRep}
      >
        <StyledIcon iconName="md-call" iconColor="white" iconOnly size={24} />
      </TouchableOpacity>
    </View>
    </HeaderGradient>
  )
}

export default ChatHeader